import { render } from "./ThePWAPrompt.vue?vue&type=template&id=dbce1a2e&scoped=true"
import script from "./ThePWAPrompt.vue?vue&type=script&lang=js"
export * from "./ThePWAPrompt.vue?vue&type=script&lang=js"

import "./ThePWAPrompt.vue?vue&type=style&index=0&id=dbce1a2e&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbce1a2e"]])

export default __exports__